import { createFocusTrap } from "focus-trap";
import { add, listen, qs, qsa, remove } from "@fluorescent/dom";

import { emit, on } from "@/neon/events";
import accordion from "@/components/accordion";

const classes = {
  visible: "is-visible",
};

const selectors = {
  closeBtn: "[data-modal-close]",
  modalContent: ".modal__content",
  accordion: ".accordion",
};

const modal = node => {
  if (!node) return;
  const focusTrap = createFocusTrap(node, { allowOutsideClick: true });
  const modalContent = qs(selectors.modalContent, node);
  let accordionElement = null;

  const events = [
    listen(qs(selectors.closeBtn, node), "click", e => {
      e.preventDefault();
      _close();
    }),
    listen(node, "keydown", ({ keyCode }) => {
      if (keyCode === 27) _close();
    }),
    on("drawerOverlay:hiding", () => _close(false)),
    on("modal:open", (state, { modalContent }) => {
      _renderModalContent(modalContent);
      _open();
    }),
  ];

  const _renderModalContent = content => {
    const clonedContent = content.cloneNode(true);
    modalContent.innerHTML = "";
    modalContent.appendChild(clonedContent);

    _initAccordion();
  };

  const _initAccordion = () => {
    const accordionItem = modalContent.querySelector(selectors.accordion);

    if (!accordionItem) return;

    accordionElement = accordion(accordionItem);
  };

  const _open = () => {
    add(node, classes.visible);
    qs(selectors.closeBtn, node).setAttribute("aria-expanded", true);
    focusTrap.activate();
    emit("drawerOverlay:show");
  };

  const _close = (hideOverlay = true) => {
    modalContent.innerHTML = "";

    focusTrap.deactivate();
    hideOverlay && emit("drawerOverlay:hide");
    remove(node, classes.visible);
    qsa(`[aria-controls="${node.id}"]`).forEach(controls => {
      controls.setAttribute("aria-expanded", false);
    });
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
    accordionElement && accordionElement.unload();
  };

  return { unload };
};

export default modal;
